import React, { createContext, useContext, useState } from 'react';
import api from '../api/client';
import { setLanguage } from '../i18n';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem('bp-user')) || null;
    } catch {
      return null;
    }
  });

  const persist = (nextUser, accessToken) => {
    if (accessToken) localStorage.setItem('bp-token', accessToken);
    localStorage.setItem('bp-user', JSON.stringify(nextUser));
    setUser(nextUser);
    if (nextUser?.language) setLanguage(nextUser.language);
  };

  const login = ({ accessToken, user: u }) => persist(u, accessToken);

  const logout = async () => {
    try {
      await api.post('/api/auth/logout');
    } catch {
      /* token may already be dead — clear locally regardless */
    }
    localStorage.removeItem('bp-token');
    localStorage.removeItem('bp-user');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, updateUser: persist, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
